import { render, staticRenderFns } from "./Public.vue?vue&type=template&id=30b96841&lang=pug"
import script from "./Public.vue?vue&type=script&lang=ts"
export * from "./Public.vue?vue&type=script&lang=ts"
import style0 from "./Public.vue?vue&type=style&index=0&id=30b96841&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports